import React from 'react'
import Panel from '../../../../shared/components/Panel'
import BudgetMonthlyPreviewPage from './components/BudgetMonthlyPreviewPage'

export default function BudgetMonthlyPreview() {
  return (
    <>
      <Panel lg={12} title="Budget Monthly Preview" showButtons={false}>
        <h3 className="page-subhead subhead">
          Preview computed monthly budgets for all active budget groups. Select a month to see projected spend.
        </h3>
      </Panel>
      <Panel lg={12} title="Monthly Budget Data" showButtons={false}>
        <BudgetMonthlyPreviewPage />
      </Panel>
    </>
  )
}
